import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input, NgZone, PLATFORM_ID, OnDestroy, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appBsCollapse]',
  exportAs: 'bsCollapse'
})
export class BsCollapseDirective implements AfterViewInit, OnDestroy {
  isShow = false;
  @Output() shown = new EventEmitter<void>();
  @Output() hidden = new EventEmitter<void>();

  constructor(
    private el: ElementRef,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      $(this.el.nativeElement).collapse('hide');

      $(this.el.nativeElement).on('shown.bs.collapse', () => {
        this.zone.run(() => {
          this.isShow = true;
          this.shown.emit();
        });
      });

      $(this.el.nativeElement).on('hidden.bs.collapse', () => {
        this.zone.run(() => {
          this.isShow = false;
          this.hidden.emit();
        });
      });
    }
  }

  toggle() {
    $(this.el.nativeElement).collapse('toggle');
  }

  show() {
    $(this.el.nativeElement).collapse('show');
  }

  hide() {
    $(this.el.nativeElement).collapse('hide');
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      $(this.el.nativeElement).collapse('dispose');
    }
  }
}
